import classNames from 'classnames';

export const Heading = ({ children, className, as = 'div' }) => {
  const Tag = as;

  return (
    <Tag
      className={classNames(['mt-2 font-semibold tracking-tight', className])}
    >
      {children}
    </Tag>
  );
};

export const Heading1 = ({ children, className, as = 'h1' }) => {
  return (
    <Heading
      as={as}
      className={classNames(['text-5xl sm:text-6xl', className])}
    >
      {children}
    </Heading>
  );
};

export const Heading2 = ({ children, className, as = 'h2' }) => {
  return (
    <Heading
      as={as}
      className={classNames(['text-4xl sm:text-5xl', className])}
    >
      {children}
    </Heading>
  );
};

export const Heading3 = ({ children, className, as = 'h3' }) => {
  return (
    <Heading
      as={as}
      className={classNames(['text-3xl sm:text-4xl', className])}
    >
      {children}
    </Heading>
  );
};

export const Heading4 = ({ children, className, as = 'h4' }) => {
  return (
    <Heading
      as={as}
      className={classNames(['text-2xl sm:text-3xl', className])}
    >
      {children}
    </Heading>
  );
};

export const Caption = ({ children, as = 'h1' }) => {
  const Tag = as;

  return (
    <Tag className="text-base font-semibold uppercase tracking-wider text-blue-08">
      {children}
    </Tag>
  );
};
